import axios from 'axios';
import apiToken from '../helpers/ApiToken';
import { randomString } from '../../shared/lib/random';

const client = axios.create({
  baseURL: '/v2/api/search',
});

const url = path => `${path}?rqid=${randomString()}`;

const SearchSource = {

  randomFlight(serverTime) {
    return client.get(url('/random-flight'), {
      headers: { Authorization: `Bearer ${apiToken(serverTime, true)}` },
    });
  },

  structuredSearch(body, serverTime) {
    return client.post(url('/structured-search'), body, {
      headers: { Authorization: `Bearer ${apiToken(serverTime, true)}` },
    });
  },

  flightNumber(body, serverTime) {
    return client.post(url('/flight-search'), body, {
      headers: { Authorization: `Bearer ${apiToken(serverTime, true)}` },
    });
  },

  airport(body, serverTime) {
    return client.post(url('/airport-search'), body, {
      headers: { Authorization: `Bearer ${apiToken(serverTime, true)}` },
    });
  },

  airportLookup(airportCode, serverTime) {
    return client.get(url(`/airport/${airportCode}`), {
      headers: { Authorization: `Bearer ${apiToken(serverTime, true)}` },
    });
  },

  airline(body, serverTime) {
    return client.post(url('/airline-search'), body, {
      headers: { Authorization: `Bearer ${apiToken(serverTime, true)}` },
    });
  },

  airlineLookup(airlineCode, serverTime) {
    return client.get(url(`/airline/${airlineCode}`), {
      headers: { Authorization: `Bearer ${apiToken(serverTime, true)}` },
    });
  },

};

export default SearchSource;



// WEBPACK FOOTER //
// ./src/sources/search.js